import mixpanel from 'mixpanel-browser';

// Mixpanel has an internal __loaded property that's not in the types
const isMixpanelLoaded = () => (mixpanel as unknown as { __loaded?: boolean }).__loaded;

const trackEvent = (eventName: string, props: Record<string, unknown>) => {
  if (isMixpanelLoaded()) {
    mixpanel.track(eventName, {
      page_url: window.location.href,
      ...props,
    });
  }
};

export const trackButtonClick = (buttonId: string, additionalProps?: Record<string, unknown>) =>
  trackEvent(`Click: ${buttonId}`, { button_id: buttonId, ...additionalProps });

export const trackFormSubmit = (formId: string, additionalProps?: Record<string, unknown>) =>
  trackEvent(`Form: ${formId}`, { form_id: formId, ...additionalProps });
